document.addEventListener('DOMContentLoaded', () => {
    const searchModalToggle = document.querySelector('.header__icon--search');
    const mobileSearchInput = document.querySelector('.mobile-search input[name="q"]');
    const searchModal = document.getElementById('search-drawer');
    const searchModalInput = document.getElementById('search-modal-input');
    const searchModalResults = document.getElementById('search-modal-results');
    const searchModalClose = document.querySelector('.search-modal__close');
    let searchTimeout = null;
    let currentRequest = null;
    const MIN_SEARCH_LENGTH = 2;
    const SEARCH_DELAY = 300; // milliseconds

    if (!searchModal || !searchModalInput || !searchModalResults) return;

    // Check if predictive search is supported
    const shopifyFeatures = document.getElementById('shopify-features');
    let predictiveSearchSupported = true;
    if (shopifyFeatures) {
      try {
        const features = JSON.parse(shopifyFeatures.textContent);
        predictiveSearchSupported = features.predictiveSearch === true;
      } catch (e) {
        console.warn('Could not parse Shopify features');
      }
    }

    if (!predictiveSearchSupported) {
      console.warn('Predictive search is not supported for this language');
    }

    // Open search modal
    function openSearchModal(query = '') {
      document.body.classList.add('search-drawer-is-open');
      if (searchModalToggle) {
        searchModalToggle.classList.add('is-clicked');
        searchModalToggle.setAttribute('aria-expanded', 'true');
      }
      searchModalInput.value = query;
      searchModalInput.focus();
      if (query.length >= MIN_SEARCH_LENGTH) {
        fetchPredictiveSearch(query);
      } else {
        searchModalResults.innerHTML = '';
      }
    }

    // Close search modal
    function closeSearchModal() {
      document.body.classList.remove('search-drawer-is-open');
      if (searchModalToggle) {
        searchModalToggle.classList.remove('is-clicked');
        searchModalToggle.setAttribute('aria-expanded', 'false');
      }
      searchModalInput.value = '';
      searchModalInput.setAttribute('aria-expanded', 'false');
      searchModalResults.innerHTML = '';
      if (currentRequest) {
        currentRequest.abort();
        currentRequest = null;
      }
    }

    // Fetch predictive search results
    function fetchPredictiveSearch(query) {
      if (!query || query.length < MIN_SEARCH_LENGTH) {
        searchModalResults.innerHTML = '';
        searchModalInput.setAttribute('aria-expanded', 'false');
        return;
      }

      // Cancel previous request if still pending
      if (currentRequest) {
        currentRequest.abort();
      }

      // Build URL with section_id parameter
      const baseUrl = window.Shopify?.routes?.root || '/';
      const searchUrl = `${baseUrl}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article,query&resources[limit]=5&section_id=predictive-search`;

      // Show loading state
      searchModalResults.classList.add('is-loading');
      searchModalInput.setAttribute('aria-expanded', 'true');
      searchModalResults.innerHTML = '<div class="predictive-search__loading">Searching...</div>';

      // Fetch results
      currentRequest = fetch(searchUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const section = doc.querySelector('#shopify-section-predictive-search');

          if (section) {
            searchModalResults.innerHTML = section.innerHTML;
          } else {
            const noResultsText = searchModalResults.dataset.noResultsText || 'No results found';
            searchModalResults.innerHTML = `<div class="predictive-search__no-results"><p>${noResultsText}</p></div>`;
          }
          searchModalResults.classList.remove('is-loading');
          currentRequest = null;
        })
        .catch(error => {
          console.error('Predictive search error:', error);
          if (error.name !== 'AbortError') {
            const errorText = searchModalResults.dataset.errorText || 'Error loading results. Please try again.';
            searchModalResults.innerHTML = `<div class="predictive-search__no-results"><p>${errorText}</p></div>`;
          }
          searchModalResults.classList.remove('is-loading');
          currentRequest = null;
        });
    }

    // The header search button is opened/closed by the shared drawer module.

    // Open modal when clicking/focusing mobile search input
    if (mobileSearchInput) {
      mobileSearchInput.addEventListener('focus', (e) => {
        e.preventDefault();
        const query = mobileSearchInput.value.trim();
        openSearchModal(query);
      });

      mobileSearchInput.addEventListener('click', (e) => {
        e.preventDefault();
        const query = mobileSearchInput.value.trim();
        openSearchModal(query);
      });
    }

    // Handle input in modal search field
    searchModalInput.addEventListener('input', (e) => {
      const query = e.target.value.trim();

      // Clear previous timeout
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }

      // If query is too short, clear results
      if (query.length < MIN_SEARCH_LENGTH) {
          searchModalResults.innerHTML = '';
          searchModalInput.setAttribute('aria-expanded', 'false');
          return;
      }

      // Debounce search
      searchTimeout = setTimeout(() => {
        fetchPredictiveSearch(query);
      }, SEARCH_DELAY);
    });

    // Handle Escape key to close modal
    searchModalInput.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeSearchModal();
      }
    });

    // Close modal button
    if (searchModalClose) {
      searchModalClose.addEventListener('click', (e) => {
        e.preventDefault();
        closeSearchModal();
      });
    }

    // Close modal when clicking outside
    searchModal.addEventListener('click', (e) => {
      if (e.target === searchModal) {
        closeSearchModal();
      }
    });

    // Handle form submission in modal
    const searchModalForm = document.querySelector('.search-modal__form');
    if (searchModalForm) {
      searchModalForm.addEventListener('submit', (e) => {
        // Allow normal form submission to search page
        // Modal will close when page navigates
      });
    }
  });

